<template>
  <ChapterBlockTemplateLinkItems v-if="children.length">
    <ChapterBlockCategoryItem
      v-for="child in children"
      :key="child.id"
      :category="child"
    />
  </ChapterBlockTemplateLinkItems>
</template>
<script lang="ts" setup>
interface ViewProps {
  category: CategorySchema;
}
const props = defineProps({
  category: null
});

const children = computed(() => props.category.children || []);
</script>
